"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldContents = void 0;
const react_1 = __importDefault(require("react"));
const FieldsetRow_1 = require("../components/FieldsetRow/FieldsetRow");
function getFieldContents({ labelWidth, wordBreak, fields }) {
    return fields
        ? fields
            .map(({ label, value, transform, hidden }, i) => {
            if (hidden) {
                return null;
            }
            return (react_1.default.createElement(FieldsetRow_1.FieldsetRow, { key: `row-field ${i}`, label: label, value: value, transform: transform, labelWidth: labelWidth, wordBreak: wordBreak }));
        })
            .filter((content) => content != null)
        : [];
}
exports.getFieldContents = getFieldContents;
//# sourceMappingURL=getFieldContents.js.map